import React, { useEffect } from "react";
import { Card, Typography, Box, Chip, Stack } from "@mui/material";
import { useDashboardData } from '../../../contexts/DashboardDataContext';
import { useDashboardContext } from '../../Dashboard';

const UserInfoWidget = () => {
    const { userData, fetchUserData } = useDashboardData();
    const { currentZone } = useDashboardContext();
    const { loading, data, error } = userData;

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Add useEffect to fetch data only if needed
    useEffect(() => {
        // Hvis vi allerede har data, ikke fetch igjen
        if (data) {
            return;
        }
        // Kun fetch hvis vi ikke har data og ikke loader
        if (!loading && !error) {
            fetchUserData();
        }
    }, [data, loading, error, fetchUserData]);
    
    // Show loading only when we have no data
    if (loading && !data) {
        return (
            <Card sx={{ width: 300, padding: 2, backgroundColor: "#1e1e1e", color: "#fff" }}>
                <Typography variant="h6" gutterBottom>User Info</Typography>
                <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                    <Typography>Loading user data...</Typography>
                </Box>
            </Card>
        );
    }

    // Show error only when we have no data
    if (error && !data) {
        return (
            <Card sx={{ width: 300, padding: 2, backgroundColor: "#1e1e1e", color: "#fff" }}>
                <Typography variant="h6" gutterBottom>User Info</Typography>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 2 }}>
                    <Typography color="error">Error loading user data</Typography>
                    <button onClick={fetchUserData} style={{ marginTop: 10 }}>Retry</button>
                </Box>
            </Card>
        );
    }

    // No data state
    if (!data) {
        return (
            <Card sx={{ width: 300, padding: 2, backgroundColor: "#1e1e1e", color: "#fff" }}>
                <Typography variant="h6" gutterBottom>User Info</Typography>
                <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                    <Typography>No user data available</Typography>
                </Box>
            </Card>
        );
    }

    return (
        <Card sx={{ width: 300, padding: 2, backgroundColor: "#1e1e1e", color: "#fff" }}>
            <h3>User Info</h3>
            <Stack spacing={1}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle1">Name:</Typography>
                    <Typography>{data.fornavn} {data.etternavn}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle1">Username:</Typography>
                    <Typography>{data.username}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle1">Role:</Typography>
                    <Chip 
                        label={data.role} 
                        size="small" 
                        color={data.role === 'admin' ? 'primary' : data.role === 'superadmin' ? 'error' : 'default'} 
                    />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle1">Last Login:</Typography>
                    <Typography>{formatDate(data.last_login)}</Typography>
                </Box>
                {loading && <Typography variant="caption" color="GrayText" align="center">Refreshing...</Typography>}
            </Stack>
        </Card>
    );
};

export default UserInfoWidget;
